;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';

	var Collection 	= APP.module('Collection');
	var Model 		= APP.module('Model');

	Collection.MenuItemsMobile = Collection.MenuItems.extend({
		initialize: function(){
			this.setDefaults();
			this.listenTo(APP.vent,'mobile_menu:replace', this.replaceMobileMenuItems);
			this.listenTo(APP.vent,'mobile_menu:removeItem', this.mobileRemoveItemFromMenu);
		},

		replaceMobileMenuItems : function(params){

			this.mobileReplace(params.param, params.replace_to);

		},

		mobileReplace: function(param, replace_to){

			this.each(function(item){
				item.replaceState({param, replace_to}, true);
			});

			return this;
		},

		mobileRemoveItemFromMenu: function(itemMethod){

			if(!itemMethod.length){
				return this;
			}

			this.each(function(item){
				item.hideItemSubMenuItem(itemMethod);
			});

			return this;
		},

		sync: function() { return null; },
		fetch: function() { return null; },
		save: function() { return null; }
	});

}(window, APP, Backbone, Marionette, $, _));
